import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { helpTopics } from "../../data/site";
import { SiteLink } from "../SiteLink";
export function AccidentHelp() {
  return <section aria-labelledby="help-title" className="border-y border-line bg-ivory" data-id="element-136" data-mp="299pgjt8wq5s6">
      <div className="page-container py-12 md:py-16" data-id="element-137" data-mp="297cup5013b9u">
        <h2 id="help-title" className="text-h2-m font-extrabold text-ink md:text-h2" data-id="element-138" data-mp="249tg23zf4whd">
          Help for the situation you’re facing
        </h2>
        <p className="mt-5 max-w-measure text-slate" data-id="element-139" data-mp="2i81ao58zflpd">
          Start with the issue that fits your crash. Each guide explains the questions that may matter to your case.
        </p>
        <ul className="mt-8 grid gap-4 md:grid-cols-2" data-id="element-140" data-mp="2s29wka3icgek">
          {helpTopics.map(topic => <li key={topic.path} className="flex" data-id="element-141" data-mp="2n372tlsz9wlw">
              <SiteLink path={topic.path} className="group flex w-full flex-col rounded-lg border border-line bg-white p-6 hover:border-ink md:p-8" data-id="element-142" data-mp="3103u1od0dg3b">
                <h3 className="text-h3 font-bold text-ink group-hover:underline group-hover:underline-offset-4" data-id="element-143" data-mp="2z4d9oi79p4q6">
                  {topic.title}
                </h3>
                <p className="mt-2 text-slate" data-id="element-144" data-mp="3849rbzv8p3bq">{topic.summary}</p>
                <span className="mt-auto inline-flex items-center gap-2 pt-5 text-label font-bold text-crimson" data-id="element-145" data-mp="382oz4gwedwh1">
                  Read more
                  <ArrowRightIcon aria-hidden="true" className="h-5 w-5" data-id="element-146" data-mp="3i2pjm6606imt" />
                </span>
              </SiteLink>
            </li>)}
        </ul>
        <p className="mt-6 text-slate" data-id="element-147" data-mp="3m284x31qkvq6">
          Don’t see your situation?{" "}
          <a href="#case-review" className="font-semibold text-crimson underline underline-offset-4 hover:text-crimson-deep" data-id="element-148" data-mp="3qw2irpunughc">
            Ask about your motorcycle crash
          </a>
          .
        </p>
      </div>
    </section>;
}